/**
 * Run work after the browser is idle, with a timeout fallback so trackers
 * still load on busy pages (mirrors LiveChat delay intent).
 */
export function scheduleIdle(fn: () => void, timeout = 3000): () => void {
    if (typeof window !== 'undefined' && typeof window.requestIdleCallback === 'function') {
        const id = window.requestIdleCallback(() => fn(), { timeout });
        return () => window.cancelIdleCallback(id);
    }
    const t = window.setTimeout(fn, timeout);
    return () => window.clearTimeout(t);
}
